var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-checkbox',_vm._b({class:_vm.inputClasses,attrs:{"label":_vm.label},on:{"change":_vm.updateInput},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}},'v-checkbox',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }